<template>
  <div class="page">
    <div class="logo"></div>
    <div class="bg"></div>
    <div class="icon1"></div>
    <div class="icon3"></div>
    <div class="icon2"></div>
    <div class="btn1" @click="changePage('/news')"></div>
    <div class="btn2" @click="changePage('/download')"></div>
  </div>
</template>
<script setup lang="ts">
const changePage = function (pageName: string) {
  router.push(pageName)
}
</script>
<style scoped>
.logo {
  margin-top: 8.31rem;
  margin-left: 5.44rem;
  width: 15.5rem;
  height: 17.06rem;
  background-image: url(/src/assets/img/icon.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  z-index: 99;
  position: relative;
}

.bg {
  position: absolute;
  top: 14.63rem;
  right: 0;
  width: 45.19rem;
  height: 32.56rem;
  background-image: url(/src/assets/img/home/bg.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  z-index: 1;
}

.icon1 {
  position: relative;
  margin: auto;
  margin-top: 20.5rem;
  width: 33.25rem;
  height: 8.75rem;
  background-image: url(/src/assets/img/home/icon1.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.icon3 {
  position: relative;
  margin: auto;
  margin-top: 2.88rem;
  width: 36rem;
  height: 5.69rem;
  background-image: url(/src/assets/img/home/icon3.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.icon2 {
  position: relative;
  margin-top: 5.56rem;
  margin-left: 8.13rem;
  width: 26.81rem;
  height: 8.13rem;
  background-image: url(/src/assets/img/home/icon2.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.btn1 {
  position: relative;
  margin-top: 2.13rem;
  margin-left: 7.69rem;
  width: 25.38rem;
  height: 4.13rem;
  background-image: url(/src/assets/img/home/btn1.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.btn2 {
  position: relative;
  margin-top: 2.63rem;
  margin-left: 7.69rem;
  width: 25.38rem;
  height: 4.13rem;
  background-image: url(/src/assets/img/home/btn2.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
</style>
